import type { Template } from "@zapier/client";

/**
 * Absolute URL for the template details page — same string the share modal copies for "Copy link".
 */
export function getTemplateDetailsAbsoluteUrl(slug: string): string {
  if (typeof globalThis.location?.origin !== "string") {
    return `/templates/details/${slug}`;
  }
  return `${globalThis.location.origin}/templates/details/${slug}`;
}

/**
 * True when template.owner is hydrated and matches the current user (only owner can share).
 * Used to gate Share action in the row and in the share modal.
 */
export function isTemplateOwnedByCurrentUser(
  template: Template | null | undefined,
  currentUserId: number | undefined,
): boolean {
  if (!template || currentUserId === undefined) return false;
  const owner = template.owner;
  if (!owner || !("id" in owner) || typeof owner.id !== "string") {
    return false;
  }
  return String(currentUserId) === owner.id;
}
